function Suppress() {
  return <></>;
}

export { Suppress };
